import {
  Model,
  ModelSnapshot,
} from 'src/containers/ProjectDiagram/types/model';
import { isModelConceptClass } from 'src/containers/ProjectDiagram/utils/data';
import { getClassHierarchy } from 'src/containers/ProjectDiagram/utils/getClassHierarchy';

export const getAllClassHierarchy = (
  model: Pick<ModelSnapshot | Model, 'nodeDataArray' | 'linkDataArray'>
) => {
  const classIrisForHierarchy = model.nodeDataArray.reduce<Set<string>>(
    (acc, nodeData) => {
      if (isModelConceptClass(nodeData)) {
        acc.add(nodeData.value);
      }
      return acc;
    },
    new Set()
  );
  return getClassHierarchy(model.linkDataArray, classIrisForHierarchy);
};
